<template>
      <v-main>
        <v-container class="h-100 d-flex align-center justify-center">
            <slot />
        </v-container>
    </v-main>
</template>
